export class FocusQueueOptionModel {
	id: number;
	title: string;
	color: string;
	active: boolean;
}
